import React, { useState } from 'react';
import { RiArrowDropDownLine, RiArrowDropUpLine } from 'react-icons/ri';


const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'What is Campus Closet?',
      answer: 'Campus Closet is an online marketplace specifically designed for campus students to buy and sell second-hand or new items with ease.',
    },
    {
      question: 'How does Campus Closet work?',
      answer: `Campus Closet makes buying and selling easy. Create an account, upload your products, or browse to buy. It's that simple.`,
    },
    {
      question: 'Is there a fee to use Campus Closet?',
      answer: 'No, Campus Closet is completely free to help students streamline their business experience.',
    },
    {
      question: 'How can I post items for sale on Campus Closet?',
      answer: 'Create an account, log in, click "My Market" next to your profile and manage your products in the admin panel.',
    },
    {
        question: 'Can I negotiate prices with sellers?',
        answer: 'Yes, negotiate prices with sellers when they call you after ordering.',
    },
    {
        question: 'Is Campus Closet available to all students on campus?',
        answer: `Yes, it's available for all students and non-students in Baraton and the metropolitan area.`,
    },
    {
        question: 'Guidelines for posting images and descriptions of products?',
        answer: 'Use clear images to attract buyers and provide the best product description to convince them.',
    },
    {
        question: 'Can you market my products after I post them on Campus Closet?',
        answer: `Yes, we offer marketing services to help showcase your products to a wider audience once you've posted them on Campus Closet.`,
    },
    {
        question: 'How do I edit or remove a listing?',
        answer: 'Find the edit and delete icons under "My Products" in the admin panel.',
    },
    {
        question: 'How do I contact a seller about an item?',
        answer: `Sellers receive your details when you order. They'll call you.`,
    },
    {
        question: 'How does the payment process work?',
        answer: 'Contact the buyer or seller. Payment is on delivery or as agreed upon.',
    },
    {
      question: 'What should I do if I encounter technical issues on the site?',
      answer: 'Contact us anytime at our phone/WhatsApp: 0729144533',
    },
    {
      question: 'How to provide feedback or suggestions?',
      answer: 'Share feedback through our communication channel here.',
    },
    {
      question: 'Is my personal information safe and secure on Campus Closet?',
      answer: 'User information is protected with stringent measures. Refer to our terms and conditions.',
    },
    // ...other FAQs
  ];

  const toggleAccordion = (index) => {
    if (index === activeIndex) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };
  return (
    <section className="bg-slate-50 pb-2">
    <div className="mx-6 sm:mx-20 md:mx-40">
      <h1 className="text-sm text-center col-span-2 font-bold p-2">popular FAQs</h1>
      <h1 className="text-xl md:text-3xl text-center col-span-2 font-bold p-5">Frequently Asked Questions</h1>
      {faqs.map((faq, index) => (
        <div key={index} className="border-b bg-blue-100 rounded-md my-2 shadow-md">
          <div
            onClick={() => toggleAccordion(index)}
            className="flex items-center justify-between p-4 cursor-pointer"
          >
            <h3 className="text-sm md:text-lg font-medium">{faq.question}</h3>
            {activeIndex === index ? <RiArrowDropUpLine size={26}/> : <RiArrowDropDownLine size={26}/>}
          </div>
          {activeIndex === index && (
            <div className="p-4 bg-gray-50">
              <p className="text-gray-700 text-sm md:text-lg">{faq.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  </section>
  );
};

export default FAQ;
